import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-fallback',
  template: `
    <div class="fallback">
      <div class="fallback-wrapper section-wrapper">
        <div>
          <h1>Not found</h1>
          <div class="fallback-message">Sorry, the page you are looking for can't be found</div>
          <a class="is-btn" href="/">Homepage</a>
        </div>
        <div>
          <i class="app-ico app-ico__404"></i>
        </div>
      </div>
    </div>`,
  styles: [
    `.fallback { margin: -36px 0; padding: 36px 0; background-color: #f5f5f5; }`,
    `.fallback h1 { margin: 28px auto; }`,
    `.fallback i { width: 100%; height: 70vh; }`,
    `.fallback-wrapper { display: grid; grid-template-columns: 50% 50%; min-height: calc(100vh - 256px); align-items: center; text-align: center; }`,
    `.fallback-message { max-width: 468px; margin: 28px auto; font-size: 24px; font-weight: 400; line-height: 36px; }`
  ]
})
export class FallbackComponent {

  constructor(
    private titleService: Title,  
    private metaTagService: Meta
  ) {
    this.titleService.setTitle('404 - Content Not Found');
    // this.metaTagService.addTags([{ name: 'robots', content: 'index, follow' }]);
  }
}
